import { useEffect, useState } from 'react'

function Extractos({ usuario }) {
  const [extractos, setExtractos] = useState([])
  const params = new URLSearchParams(window.location.search)
  useEffect(() => {
    fetch(`/api/archivos?cedula=${usuario.cedula}&token=${params.get('token') || usuario.token}`)
      .then(response => response.json())
      .then(data => {
        setExtractos(data)
      })
  }, [])
  return (
    <>
      <img src="/coop-logo.png" alt="" />
      {
        Object.entries(extractos).length ? 
         Object.entries(extractos).map(([tipo, fechas]) => (
            <>
              <h4>Lista de extractos disponibles ({tipo.replace('_', ' ')})</h4>
              <ul>
                {
                  fechas.map(fecha => (
                    <>
                      <li>
                        <a 
href={`/api/${tipo}?cedula=${usuario.cedula}&fecha=${fecha}&password=${usuario.cedula.slice(-4)}&token=${params.get('token')}`} 
target="_blank">{fecha}</a>
                      </li>
                    </>
                  ))
                }
              </ul>
            </>
          ))
        : 
          <p>No hay extractos disponibles</p>
      }
    </>
  )
}

export default Extractos
